export const PAYMENT_TO_SPOTAHOME = 'through_spotahome';
export const PAYMENT_TO_LANDLORD = 'to_landlord';

// Frequencies
export const FREQUENCY_MONTHLY = 'monthly';
export const FREQUENCY_WEEKLY = 'weekly';
export const FREQUENCY_BI_MONTHLY = 'biMonthly';
export const FREQUENCY_ONE_PAYMENT = 'onePayment';

// Payment methods
export const PAYMENT_METHOD_CASH = 'cash';
export const PAYMENT_METHOD_BANK_TRANSFER = 'bankTransfer';
export const PAYMENT_METHOD_CREDIT_CARD = 'creditCard';
export const PAYMENT_METHOD_PAY_TO_PROVIDER = 'payToProvider';
export const PAYMENT_METHOD_PAY_THROUGH_SPOTAHOME = 'payThroughSpotahome';
export const PAYMENT_METHOD_PAYPAL = 'paypal';

// Cost types
export const COST_TYPE_SAH_FEE = 'spotahomeFee';
export const COST_TYPE_DOWNPAYMENT = 'downpayment';
